export default __webpack_public_path__ + "static/media/ico_app_disabled.e3721bf2.svg";